var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    _vm._b(
      {
        attrs: { persistent: "" },
        scopedSlots: _vm._u(
          [
            !_vm.noActivator
              ? {
                  key: "activator",
                  fn: function (ref) {
                    var on = ref.on
                    return [
                      _vm._t(
                        "activator",
                        function () {
                          return [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { top: "", disabled: !_vm.tooltip },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var tooltipOn = ref.on
                                        return [
                                          _vm.icon
                                            ? _c(
                                                "v-btn",
                                                _vm._g(
                                                  {
                                                    attrs: {
                                                      icon: "",
                                                      large: _vm.large,
                                                      disabled: _vm.disabled,
                                                    },
                                                  },
                                                  Object.assign(
                                                    {},
                                                    on,
                                                    tooltipOn
                                                  )
                                                ),
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(_vm._s(_vm.icon)),
                                                  ]),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [_c("span", [_vm._v(_vm._s(_vm.tooltip))])]
                            ),
                          ]
                        },
                        { on: on }
                      ),
                    ]
                  },
                }
              : null,
          ],
          null,
          true
        ),
        model: {
          value: _vm.computedDialog,
          callback: function ($$v) {
            _vm.computedDialog = $$v
          },
          expression: "computedDialog",
        },
      },
      "v-dialog",
      _vm.computedDialogProps,
      false
    ),
    [
      _c(
        "v-form",
        {
          ref: "form",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submitForm.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "v-card",
            [
              _vm.title
                ? _c("v-card-title", [
                    _c("span", { staticClass: "text-h5" }, [
                      _vm._v(_vm._s(_vm.title)),
                    ]),
                  ])
                : _vm._e(),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        value: _vm.error,
                        transition: "scale-transition",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.error) + " ")]
                  ),
                  _vm._t("default", null, { item: _vm.value }),
                ],
                2
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: { click: _vm.closeDialog },
                    },
                    [_vm._v("Close")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "blue darken-1",
                        text: "",
                        type: "submit",
                        disabled: _vm.disableSubmit,
                        loading: _vm.saveInProgress,
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.submitText) + " ")]
                  ),
                  _vm._t("append-actions"),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }